import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AiOutlinePlus } from 'react-icons/ai';
import { MdAutorenew } from 'react-icons/md';

import CardPriceTag from '../CardPriceTag';
import CardSellNums from '../CardSellNums';

const CardCouponFooterEdit = ({
    nbr_id,
    nbr_price,
    nbr_available,
    nbr_sold,
    nbr_redeemed,
    str_currency='',
    fct_handleDelete
}) => {
    const navigate = useNavigate()
    return (
        <div className="card-footer-offer">
            <CardPriceTag
                nbr_price={nbr_price}
                str_currency={str_currency}
            />
            <CardSellNums
                nbr_available={nbr_available}
                nbr_soldOrReserved={nbr_sold}
                nbr_redeemed={nbr_redeemed}
            />
            <div className="action-el">
                <div className="buttons">
                    <button
                        className="btn btn-sm btn-submit btn-icon"
                        onClick={() => navigate(`../reuse/${nbr_id}`)}
                    >
                        <MdAutorenew />
                    </button>
                    <button
                        className="btn btn-sm btn-submit btn-icon btn-cross"
                        onClick={fct_handleDelete}
                    >
                        <AiOutlinePlus />
                    </button>
                </div>
            </div>
        </div>
    )
}

CardCouponFooterEdit.propTypes = {
    nbr_id: PropTypes.number.isRequired,
    nbr_price: PropTypes.number.isRequired,
    nbr_available: PropTypes.number.isRequired,
    nbr_sold: PropTypes.number.isRequired,
    nbr_redeemed: PropTypes.number.isRequired,
    str_currency: PropTypes.string,
    fct_handleDelete: PropTypes.func.isRequired
}

export default CardCouponFooterEdit
